import React, { createContext, ReactNode, useContext, useMemo, useState } from 'react'

type PhoneVerificationContextValue = {
  isTrackingVerified: (tracking?: string) => boolean
  verifyTracking: (tracking?: string) => void
}

const PhoneVerificationContext = createContext<PhoneVerificationContextValue | undefined>(undefined)

export const PhoneVerificationProvider = ({ children }: { children: ReactNode }) => {
  const [verifiedTrackings, setVerifiedTrackings] = useState<Record<string, boolean>>({})

  const value = useMemo<PhoneVerificationContextValue>(
    () => ({
      isTrackingVerified: (tracking?: string) => {
        console.log("PhoneVerificationProvider", tracking, verifiedTrackings)
        return tracking ? !!verifiedTrackings[tracking] : false
      },
      verifyTracking: (tracking?: string) => {
        if (!tracking) {
          return
        }

        setVerifiedTrackings(prev => {
          if (prev[tracking]) {
            return prev
          }

          return {
            ...prev,
            [tracking]: true,
          }
        })
      },
    }),
    [verifiedTrackings]
  )

  return <PhoneVerificationContext.Provider value={value}>{children}</PhoneVerificationContext.Provider>
}

export const usePhoneVerification = () => {
  const context = useContext(PhoneVerificationContext)

  if (!context) {
    throw new Error('usePhoneVerification must be used within PhoneVerificationProvider')
  }

  return context
}
